// extracted by mini-css-extract-plugin
export default {"wrapper":"Empty_wrapper__aYkBS","tips":"Empty_tips__7WAnp"};